/**
 * Foundation · Sequence — elaborazione sequenziale di più soggetti (dipendenti, clienti, pratiche…).
 * Puro: posizione, avanzamento, soggetto successivo da completare, ultimo soggetto elaborato.
 */
export const SEQUENCE_MODES = Object.freeze(["ask", "auto", "return"]);

export function sequenceState(subjects, statuses, currentId, isDone = (s) => s === "applied") {
  const total = subjects.length;
  const index = subjects.findIndex((s) => s.id === currentId);
  const completed = subjects.filter((s) => isDone(statuses[s.id]?.status)).length;
  let next = null;
  for (let k = 1; k <= total; k++) {
    const cand = subjects[(Math.max(index, -1) + k) % total];
    if (cand && cand.id !== currentId && !isDone(statuses[cand.id]?.status)) { next = cand; break; }
  }
  return { total, index, position: index + 1, completed, next, allDone: total > 0 && completed === total };
}

const KEY = (workflow, scope) => `gi.sequence.${workflow}${scope ? `.${scope}` : ""}`;
export const rememberLastSubject = (workflow, scope, id) => { try { localStorage.setItem(KEY(workflow, scope), id); } catch { /* storage non disponibile */ } };
export const lastSubject = (workflow, scope) => { try { return localStorage.getItem(KEY(workflow, scope)); } catch { return null; } };
